import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import { LampProvider } from "./contexts/LampContext.jsx";
import Layout from "./components/Layout.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import StructuredData from "./components/StructuredData.jsx";

// Eager load Home for faster LCP
import Home from "./pages/Home.jsx";

// Lazy load other pages

const Services = lazy(() => import("./pages/Services.jsx"));
const Work = lazy(() => import("./pages/Work.jsx"));
const GalleryPage = lazy(() => import("./pages/GalleryPage.jsx"));
const ContactPage = lazy(() => import("./pages/ContactPage.jsx"));

// Simple loading spinner component
const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f5f5f5' }}>
    <div className="loader"></div>
    <style>{`
      .loader {
        border: 4px solid #f3f3f3;
        border-top: 4px solid #333;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

export default function App() {
  return (
    <Router>
      <StructuredData />
      <LampProvider>
        <ScrollToTop />
        <Layout>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/work" element={<Work />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Suspense>
        </Layout>
      </LampProvider>
    </Router>
  );
}
